import { connect, useDispatch } from "react-redux";
// import {
//   getNotification,
//   getStudentResource,
// } from "../../../../../action/masters/appActionCreator";
import { useEffect, useState } from "react";
import { Draggable } from "react-drag-reorder";
import {
  getStudentResources,
  updateStudentResourcePriority,
} from "../../../../action/masters/studentResourceActionCreator";
import {
  changePositionOnDrag,
  prioratiseItems,
} from "../../../../common-functions/commonFunctions";
import { cloneDeep, baseURL } from "../../../../constants/commonConstants";
import { getAlertData } from "../../../../helper/sweet-alert";
import {
  IUpdateStudentResourcePriority,
  IStudentResourceData,
} from "../../../../models/master/studentResource";
import { setStudentResources } from "../../../../store/slices/master/studentResourceSlice";
import LoaderSpinner from "../../../../common-components/loader";

const PriorityStudentResource = (props: IUpdateStudentResourcePriority) => {
  const {
    updateStudentResourcePriority,
    getStudentResources,
    studentResources,
    configUserRole,
  } = props;
  const [filteredItems, setfilteredItems] = useState<any[]>([]);
  const [loader, setLoader] = useState(true);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const dispatch = useDispatch();

  const saveChangedPos = async (currentPos: any, newPos: any) => {
    if (currentPos != newPos) {
      setLoader(true);
      let _items = changePositionOnDrag(filteredItems, currentPos, newPos);
      await setfilteredItems(_items);
      updateStudentResourcePriority(_items, setAlert);
    }
  };

  const ChangeVisibleOrNot = async (id: number, _displayOrNot: boolean) => {
    /////method 1
    setLoader(true);
    let index = filteredItems.findIndex((x) => x.id == id);
    let _afterFilteration = [];
    let _filteredItems = [...filteredItems];
    let selectedItem = _filteredItems.splice(index, 1);
    selectedItem[0].displayOrNot = _displayOrNot;

    selectedItem[0].priority = null;
    _afterFilteration = [
      ...prioratiseItems(_filteredItems.filter((x) => x.displayOrNot == true)),
      ...selectedItem,
      ..._filteredItems.filter((x) => x.displayOrNot == false),
    ];
    let _items = prioratiseItems(_afterFilteration);
    
    setfilteredItems([..._items]);
    updateStudentResourcePriority(_items, setAlert);

    /////method 2
    // let _filteredItems = [...filteredItems]
    // let item = _filteredItems[index];
    // item.displayOrNot = __displayOrNot;
    // _filteredItems[index] = item;
    // updateAppPriority(item, setAlert);
    // setFilteredItems(_filteredItems);
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setLoader(false);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const getAllStudentResources = async (configUserRoleId: number) => {
    setLoader(true)
    try{
      await getStudentResources(configUserRoleId);
    }
    finally{
      setLoader(false)
    }
  };

  useEffect(() => {
    getAllStudentResources(configUserRole);
    return () => {
      dispatch(setStudentResources([]));
    };
  }, [configUserRole]);

  useEffect(() => {
    studentResources && setfilteredItems(cloneDeep(studentResources));
  }, [studentResources]);

  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Student Resource</h2>
        </div>
        <ul className="d-flex gap-3 flex-wrap mt-28">
          {loader ? (
            <LoaderSpinner/>
          ) : filteredItems && filteredItems?.length > 0 ? (
            <>
              <Draggable
                onPosChange={async (currentPos, newPos) => {
                  await saveChangedPos(currentPos, newPos);
                }}
              >
                {filteredItems
                  .filter((item: IStudentResourceData) => item.displayOrNot)
                  .map((studentResource: IStudentResourceData, index: number) => (
                    <li className="admin-card">
                      <div className="top">
                        <span className="handle">
                          <img src="/assets/images/drag.svg" />
                        </span>
                        <span className="counter">
                          {studentResource.priority}
                        </span>
                        <div className="form-checkbox">
                          <input
                            type="checkbox"
                            checked={studentResource.displayOrNot}
                            id={studentResource.priority + "studentResource"}
                            onChange={() => {
                              
                              ChangeVisibleOrNot(
                                studentResource.id ?? 0,
                                !studentResource.displayOrNot
                              );
                            }}
                          />
                          <label
                            htmlFor={studentResource.priority + "studentResource"}
                          ></label>
                        </div>
                      </div>
                      <div className="btm">
                        <div className="img">
                          <img
                            src={
                              studentResource.image
                                ? baseURL + studentResource.image
                                : ""
                            }
                            alt=""
                          />
                        </div>
                        <h2>{studentResource.name}</h2>
                        <p>{studentResource.description}</p>
                      </div>
                    </li>
                  ))}
              </Draggable>
              {filteredItems
                .filter((item: IStudentResourceData) => !item.displayOrNot)
                .map((studentResource: IStudentResourceData, index: number) => (
                  <li className="admin-card">
                    <div className="top">
                      <span className="handle">
                        <img src="/assets/images/drag.svg" />
                      </span>
                      <span className="counter">{}</span>
                      <div className="form-checkbox">
                        <input
                          type="checkbox"
                          checked={studentResource.displayOrNot}
                          id={studentResource.priority + "studentResource"}
                          onChange={() => {
                            
                            ChangeVisibleOrNot(
                              studentResource.id ?? 0,
                              !studentResource.displayOrNot
                            );
                          }}
                        />
                        <label
                          htmlFor={studentResource.priority + "studentResource"}
                        ></label>
                      </div>
                    </div>
                    <div className="btm">
                      <div className="img">
                        <img
                          src={
                            studentResource.image
                              ? baseURL + studentResource.image
                              : ""
                          }
                          alt=""
                        />
                      </div>
                      <h2>{studentResource.name}</h2>
                      <p>{studentResource.description}</p>
                    </div>
                  </li>
                ))}
            </>
          ) : (
            <p>No Records Found</p>
          )}
        </ul>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getStudentResources: (configUserRole: number) =>
    getStudentResources(configUserRole),
  updateStudentResourcePriority: (data: any, callBack: Function) =>
    updateStudentResourcePriority(data, callBack),
};

function mapStateToProps(state: any) {
  return {
    studentResources: state.studentResource.studentResources,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PriorityStudentResource);
